import React from 'react';
import { SETTING } from 'interfaces/settings';

export enum SettingOptionType {
    MULTI = 'multi',
    SINGLE = 'single',
    LOGGING = 'logging',
    DISPOSITIONS = 'dispositions',
}

export interface SettingRowMulti {
    settings: SETTING[];
    rowLabel: string;
    type: SettingOptionType.MULTI
}

export interface SettingRowSingle {
    setting: SETTING
    type: SettingOptionType.SINGLE
}

export interface AutomationOption {
    type: SettingOptionType.LOGGING
}

export interface DispositionsOption {
    type: SettingOptionType.DISPOSITIONS
}

export type SettingOption = SettingRowMulti | SettingRowSingle | AutomationOption | DispositionsOption

export interface SettingSectionConfig {
    section: string;
    options: SettingOption[];
}
